import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=3a3f9199&scoped=true"
import script from "./welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./welcome.vue?vue&type=script&setup=true&lang=js"
import style0 from "./welcome.vue?vue&type=style&index=0&id=3a3f9199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f9199",
  null
  
)

export default component.exports